import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { logoutUser } from '../../actions/auth';
import __ from '../../helpers/translation';
import { fetchInstructions } from '../../actions/instructions';

const propTypes = {
  auth: PropTypes.object.isRequired,
  logoutUser: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  actions: PropTypes.element,
  showBackLink: PropTypes.bool,
  hideNavigation: PropTypes.bool,
  fetchInstructions: PropTypes.func.isRequired
};

class Header extends Component {
  constructor (props) {
    super(props);
    this.state = {
      title: this.props.title,
      showBackLink: this.props.showBackLink && false,
      hideNavigation: this.props.hideNavigation && false,
      instructions: []
    };
  }

  handleLogout () {
    this.props.logoutUser(() => { 
      window.$('#modal-navigation').on('hidden.bs.modal', () => {
        this.props.history.push('/') 
      });
      window.$('#modal-navigation').modal('hide');
    });
  }

  componentDidMount () {
    this.props.fetchInstructions()
      .then((data) => { 
          this.setState({
              instructions: data.instructions
          });
      })
      .catch(error => {
          return Promise.reject(error)
      });
  }

  render () {
    const { instructions } = this.state;
    return (
      <React.Fragment>
      <div className="container-fluid bgdarkgreen header-top d-flex flex-row align-items-center">
          <div className="container">
              <div className="row">
                  { 
                    this.props.showBackLink &&
                    <div className="col-2 multiple-tabs-left">
                      <i className="fal fa-chevron-left"></i>
                    </div>
                  }
                  <div className="col-12 text-center">
                      <h3 className="text-white text-uppercase m-0 fw-900">{ this.props.title }</h3>
                  </div>
                  { 
                    !this.props.hideNavigation &&
                    <div className="col-2 multiple-tabs">
                      <a className="cur-p instructions-pdf-link" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#modal-instructions">
                          <i className="far fa-info-circle"></i>
                      </a>
                      <a className="cur-p" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#modal-navigation">
                          <i className="far fa-ellipsis-h"></i>
                      </a>
                    </div>
                  }
              </div>
          </div>
      </div>
      <div className="modal bottom modal-menu" id="modal-navigation" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div className="modal-dialog" role="document">
              <div className="modal-content align-items-center justify-content-center">
                  <div className="container">
                      <div className="row mb-5">
                          <div className="col-md-6 col-12 offset-md-3 d-flex flex-column line-height-40">
                              { this.props.actions }
                              <a className="d-flex flex-row text-dark font-size-18 cur-p" onClick={() => this.handleLogout()} >
                                <div className="icon-container">
                                    <i className="far fa-sign-out-alt"></i>
                                </div>
                                <p>{ __('app.navigation.logout') }</p>
                              </a>
                              <a className="d-flex flex-row text-dark font-size-18 cur-p" href='/debug' >
                                <div className="icon-container">
                                    <i className="far fa-bug"></i>
                                </div>
                                <p>Debug info</p>
                              </a>
                          </div>
                      </div>
                  </div>
                  <a data-dismiss="modal" className="textred text-uppercase font-size-18 cur-p">{ __('app.general.close_menu') }</a>
              </div>
          </div>
      </div>
      <div className="modal bottom modal-menu" id="modal-instructions" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div className="modal-dialog" role="document">
              <div className="modal-content align-items-center justify-content-center">
                  <div className="container">
                      <div className="row mb-5">
                          <div className="col-md-6 col-12 offset-md-3 d-flex flex-column line-height-40">
                            {instructions.map(item => (
                              <a key={item.id} className="d-flex flex-row text-dark font-size-18 cur-p" href={item.image} target="_blank">
                                <div className="icon-container">
                                    <i className="far fa-download"></i>
                                </div>
                                <p>{ item.name }</p>
                              </a>
                            ))}
                          </div>
                      </div>
                  </div>
                  <a data-dismiss="modal" className="textred text-uppercase font-size-18 cur-p">{ __('app.general.close_menu') }</a>
              </div>
          </div>
      </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = { 
  logoutUser,
  fetchInstructions
};
const mapStateToProps = ({ auth }) => ({ auth });

Header.propTypes = propTypes;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { pure: false }
)(withRouter(Header));
